import React from 'react';
import './Home.css';
import logo512 from '../../resources/assets/logo512.png'
import siteConfig from '../../resources/data/config.js';
import { useEffect } from 'react';
import { fadeInOnLoad } from '../Global/Global.js';
import '../Global/Global.css';
import TextSignup from '../TextSignup/TextSignup.js';

function homeImage() {
  return (
    <div style={{backgroundImage: `url(${logo512})` }} alt="Facial Treatment" className="background-image" loading="lazy" height="100" width="100" />
  );
}

function Home() {
  return (
    <div className="home">
      {homeImage()}
      <div className='home-text'>
        <HomeTitle />
      </div>
      <HomeText />
    </div>
  );
}

function HomeTitle() {
  useEffect(() => {
    fadeInOnLoad(document.querySelector('.home-title'), 0);
    fadeInOnLoad(document.querySelector('.home-title2'), 200);
    fadeInOnLoad(document.querySelector('.home-bio-header'), 300);
    fadeInOnLoad(document.querySelector('.home-bio-subheader'), 340);
  }, []);

  return (
    <div>
      <h1 className='home-title fade-in'>Welcome to {siteConfig.name}</h1>
      <p className='home-title2 fade-in'>Your journey to radiant skin starts here!</p>
    </div>
  );
}


function HomeText() {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
    });
  }, { threshold: 0.4 });
    const paragraph = document.querySelectorAll('.home-bio-paragraph')
    paragraph.forEach((el) => observer.observe(el));
  }, []);

  return (
    <div className='home-bio'>
        <h2 className='home-bio-header fade-in'>My Story</h2>
        <h3 className='home-bio-subheader fade-in'>Over 31 years of experience in holistic and medical skincare.</h3>
        <p className="home-bio-paragraph">Guided by a deep passion for healing and wellness, I traveled far to attend the European International Institute school for skincare, which was unheard of at the time. As a life long vegetarian, I have always been drawn to spa therapies and the power of natural, plant-based ingredients.</p>
        <p className="home-bio-paragraph">I trained alongside my mentor from Greece, who was a 5th generation beauty and wellness expert. She taught me how to create my own skincare products from scratch, giving me a deep understanding of which ingredients are best for each skin type. As the industry evolved, I grew with it by working alongside doctors in medical spas, helping me integrate advanced, result-driven treatments into my practice.</p>
        <p className="home-bio-paragraph">Today, I offer a unique combination of natural skincare and medical oriented treatments. Helping my clients relax, achieve a healthy natural glow, and look younger is incredibly rewarding. This work feels less like a career and more like a calling.</p>
        <p className="home-bio-paragraph">I truly enjoy seeing my clients transform from stressed to relaxed, radiant, and rejuvenated. I look forward to welcoming new clients and sharing this unique approach to skincare with you.</p>
        <p className="home-skin-angel">Your personal skin angel</p>
        <p className="home-licensed-esthetician">Licensed Esthetician in New Jersey and Florida.</p>
        <TextSignup buttonText="Sign up for specials via text"/>
    </div>
  );
}

export default Home;